import { AnalyticsEventName } from './constants';
import { trackEvent } from './utils';
import { ItemAnalyticsModel } from '@/@types/client-api';
import { ConvertItemAnalyticsModelBase } from './analyticsUtils';

export const trackViewFacultyItem = (itemAnalyticsModel?: ItemAnalyticsModel) => {
  const item = ConvertItemAnalyticsModelBase(itemAnalyticsModel);

  trackEvent({
    eventName: AnalyticsEventName.ViewFacultyItem,
    parameters: item
      ? {
          items: [item]
        }
      : {}
  });
};
